module.exports = __webpack_public_path__ + "static/media/new-york-robert-bye.5f91fc68.jpg";